/* eslint-disable jsx-a11y/no-static-element-interactions */
import { format } from 'date-fns'
import DOMPurify from 'dompurify'
import { MapPin, Money, NewspaperClipping, WifiHigh } from 'phosphor-react'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'
import { FeathersContext } from '../../../../services/feathers'
import { remote } from '../../../../utils/utils'
import * as s from './CardCandidate.styles'

const CustomCardCandidate = ({ job, app, handleChatbotApply }) => {
  const feathers = useContext(FeathersContext)

  const { data } = useQuery({
    queryKey: ['company', job?.company_id],
    queryFn: async () => {
      const result = await feathers.service('lambda-talent').find({
        query: {
          type: 'getCompany',
          companyId: job.company_id,
        },
      })
      return result
    },
  })

  const { t } = useTranslation(['campaign', 'chatbot'], {
    useSuspense: false,
  })

  const createMarkup = (html) => ({
    __html: DOMPurify.sanitize(html),
  })

  const displayStatus = () => (
    <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <span
        style={{
          width: '8px',
          height: '8px',
          display: 'inline-block',
          backgroundColor: '#659DFF',
          borderRadius: '50%',
        }}
      />
      <span>{t('chatbot:candidate.applied')}</span>
    </span>
  )

  return (
    <s.CardCandidateWrapper>
      <div className="top">
        <div className="mag">
          {data?.standalone?.topLogoId && (
            <img
              className="logo"
              src={data.standalone.topLogoId}
              alt="logo company"
            />
          )}
          {data?.name?.length && <p className="jobName">{data?.name}</p>}
        </div>
        <div className="tag">
          {app.createdAt ? (
            displayStatus(app.classification)
          ) : (
            <span style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
              <span className="apply" />
              <span
                className="apply-btn"
                onClick={() => handleChatbotApply(app.offer)}
                onKeyDown={() => handleChatbotApply(app.offer)}
              >
                Postuler maintenant
              </span>
            </span>
          )}
        </div>
      </div>
      <div className="main">
        <p className="title">{job?.displayName || job?.name}</p>
      </div>
      <div className="bottom">
        <p className="candidateDate">
          Candidature le :
          {app.createdAt ? (
            format(new Date(app.createdAt), 'dd/MM/yyyy')
          ) : (
            <span style={{ opacity: '.4' }}>(En attente de candidature)</span>
          )}
        </p>
        <div className="lastRow">
          <div className="textWithIcon">
            {job?.contractType ? (
              <>
                <NewspaperClipping size={14} />
                <p>{job?.contractType}</p>
              </>
            ) : null}
          </div>

          <div className="textWithIcon">
            {job?.location?.city ? (
              <>
                <MapPin size={14} />
                <p>{job?.location?.city}</p>
              </>
            ) : null}
          </div>

          <div className="textWithIcon">
            <Money size={14} />
            <p>
              {job?.salaryRange?.minValue && job?.salaryRange?.maxValue
                ? `${job?.salaryRange?.minValue}K - ${job?.salaryRange?.maxValue}K`
                : null}
            </p>
          </div>

          {job.remoteWorking && (
            <div className="textWithIcon">
              <WifiHigh size={14} />
              <span
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={createMarkup(
                  remote(job.remoteWorking, t),
                )}
              />
            </div>
          )}
        </div>
      </div>
    </s.CardCandidateWrapper>
  )
}

export default CustomCardCandidate
